import * as React from 'react';

import {
    floatingResizeCornerStyles,
    floatingResizeHandleStyles,
    ResizeEdge,
    resizeHandleHeightStyles,
    resizeHandleWidthStyles
} from './agent-portal.styles';

interface AgentResizeHandlesProps {
    isDocked: boolean;
    dockSide: 'left' | 'right';
    isResizingWidth: boolean;
    isResizingHeight: boolean;
    resizingEdge: ResizeEdge | null;
    onResizeWidthStart: (e: React.MouseEvent) => void;
    onResizeHeightStart: (e: React.MouseEvent) => void;
    onFloatingResizeStart: (e: React.MouseEvent, edge: ResizeEdge) => void;
}

export const AgentResizeHandles: React.FC<AgentResizeHandlesProps> = ({
    isDocked,
    dockSide,
    isResizingWidth,
    isResizingHeight,
    resizingEdge,
    onResizeWidthStart,
    onResizeHeightStart,
    onFloatingResizeStart
}) => {
    if (isDocked) {
        // Docked mode: 2 handles (width + height)
        return (
            <>
                <div
                    css={resizeHandleWidthStyles(dockSide)}
                    onMouseDown={onResizeWidthStart}
                    data-resizing={isResizingWidth}
                    title="Drag to resize width"
                />
                <div
                    css={resizeHandleHeightStyles}
                    onMouseDown={onResizeHeightStart}
                    data-resizing={isResizingHeight}
                    title="Drag to resize height"
                />
            </>
        );
    }

    // Floating mode: 8 handles (4 edges + 4 corners)
    const handleResizeTopLeft = (e: React.MouseEvent) => onFloatingResizeStart(e, 'top-left');
    const handleResizeTopRight = (e: React.MouseEvent) => onFloatingResizeStart(e, 'top-right');
    const handleResizeBottomLeft = (e: React.MouseEvent) => onFloatingResizeStart(e, 'bottom-left');
    const handleResizeBottomRight = (e: React.MouseEvent) => onFloatingResizeStart(e, 'bottom-right');
    const handleResizeTop = (e: React.MouseEvent) => onFloatingResizeStart(e, 'top');
    const handleResizeRight = (e: React.MouseEvent) => onFloatingResizeStart(e, 'right');
    const handleResizeBottom = (e: React.MouseEvent) => onFloatingResizeStart(e, 'bottom');
    const handleResizeLeft = (e: React.MouseEvent) => onFloatingResizeStart(e, 'left');

    return (
        <>
            {/* Corner handles */}
            <div
                css={floatingResizeCornerStyles('top-left')}
                onMouseDown={handleResizeTopLeft}
                data-resizing={resizingEdge === 'top-left'}
                title="Drag to resize"
            />
            <div
                css={floatingResizeCornerStyles('top-right')}
                onMouseDown={handleResizeTopRight}
                data-resizing={resizingEdge === 'top-right'}
                title="Drag to resize"
            />
            <div
                css={floatingResizeCornerStyles('bottom-left')}
                onMouseDown={handleResizeBottomLeft}
                data-resizing={resizingEdge === 'bottom-left'}
                title="Drag to resize"
            />
            <div
                css={floatingResizeCornerStyles('bottom-right')}
                onMouseDown={handleResizeBottomRight}
                data-resizing={resizingEdge === 'bottom-right'}
                title="Drag to resize"
            />
            {/* Edge handles */}
            <div
                css={floatingResizeHandleStyles('top')}
                onMouseDown={handleResizeTop}
                data-resizing={resizingEdge === 'top'}
                title="Drag to resize height"
            />
            <div
                css={floatingResizeHandleStyles('right')}
                onMouseDown={handleResizeRight}
                data-resizing={resizingEdge === 'right'}
                title="Drag to resize width"
            />
            <div
                css={floatingResizeHandleStyles('bottom')}
                onMouseDown={handleResizeBottom}
                data-resizing={resizingEdge === 'bottom'}
                title="Drag to resize height"
            />
            <div
                css={floatingResizeHandleStyles('left')}
                onMouseDown={handleResizeLeft}
                data-resizing={resizingEdge === 'left'}
                title="Drag to resize width"
            />
        </>
    );
};
